import { Document } from '@contentful/rich-text-types';
import { CloudinaryProductAsset, ContentfulProduct } from 'shared/types/content';
import { cloudinaryAssetToImage, isCloudinaryImage } from './cloudinaryAssetToImage';
import { ImageProps } from '../../components/commercetools-ui/atoms/image';
import { UIProductContent } from '../../components/commercetools-ui/organisms/product/product-details/types';

export const toUIProductContent = (
  content: ContentfulProduct | undefined,
  assets: CloudinaryProductAsset[] | undefined,
): UIProductContent => {
  const images: ImageProps[] = [];

  for (const asset of assets ?? []) if (isCloudinaryImage(asset)) images.push(cloudinaryAssetToImage(asset));

  return {
    description: content?.attributes?.description as Document | undefined,
    blurb: content?.attributes?.blurb as Document | undefined,
    highlights: content?.attributes?.descriptionHighlights as Document | undefined,
    whatsInTheBox: content?.attributes?.descriptionWhatsInTheBox as Document | undefined,
    frequentlyAskedQuestions: content?.attributes?.frequentlyAskedQuestions?.map((item) => ({
      id: item.contentId,
      question: item.attributes?.question ?? '',
      answer: item.attributes?.answer as unknown as Document,
    })),
    images,
    categoryCtaText: content?.attributes?.ctaText,
    categoryCtaUrl: content?.attributes?.ctaUrl
  };
};
